export default "__VITE_ASSET__L8Fs_TmwgLeEJ8oqil9r1g__"